import { useQuery } from '@tanstack/react-query';
import { fetchSpendCategoryList } from 'components/RfxDrawers/api';

interface SpendCategory {
  category_type: string;
  id: number;
  name: string;
}

interface SelectOption {
  label: string;
  value: number;
}

export const useSpendCategories = () => {
  return useQuery({
    initialData: [],
    queryFn: async () => {
      const response = await fetchSpendCategoryList();

      return response.data.spend_categories
        .filter((category: SpendCategory) => category.name === 'None' && category.category_type !== 'Tail End Spend')
        .map((category: SpendCategory) => ({
          label: category.category_type,
          value: category.id,
        }))
        .sort((a: SelectOption, b: SelectOption) => a.label.localeCompare(b.label));
    },
    queryKey: ['spend_category_list']
  });
};
